
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { JobService } from "@/services/job-service";
import { Job } from "@/models/job";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppContactSearchWithBrowseAndCreate from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import { Contact } from "@/models/base";
import { SupplierService } from "@/services/supplier-service";
import { TranslateResult } from "vue-i18n";
import { ProductService } from "@/services/product-service";

export default Vue.extend({
	data(){
		return {
			JobService,
			krampSupplier: null as null | Contact,
			config: DossierConfigService.getKrampConfig()
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/products", value: this.$ct("products")},
				{value: this.$ct("kramp")}
			] as IBreadCrumb[];
		},
		krampModule():MODULE{
			return MODULE.KOPPELING_KRAMP;
		},
		hasModule():boolean {
			return AuthService.hasModule(this.krampModule);
		},
		job():Job | null{
			return this.JobService.getJobs().find(j=>j.Name == "kramp-import") || null;
		},
		jobProgress():number {
			if (!this.job) return 0;
			return this.job.getProgressBarValue();
		},
		isFtpDataEmpty():boolean {
			if (this.config.Host) {
				return false;
			}
			if (this.config.Username) {
				return false;
			}
			if (this.config.Password) {
				return false;
			}
			return true;
		},
		saveIcon():string{
			if (this.isFtpDataEmpty) {
				return "save";
			}
			return "download";
		},
		saveButtonText():TranslateResult{
			if (this.isFtpDataEmpty) {
				return this.$ct("common.save");
			}
			return this.$ct("import-products");
		},
		saveButtonDisabeled():boolean {
			if (this.job) {
				return true;
			}
			if (this.config.SupplierID == 0) {
				if (this.isFtpDataEmpty) {
					return false;
				}
				return true;
			}
			return false;
		}
	},
	methods: {
		async saveButtonClicked(){
			await this.saveSettings();
			if (!this.isFtpDataEmpty){
				await this.startImport();
			}else{
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
			}
		},
		async saveSettings(){
			this.config = await DossierConfigService.saveKrampConfig(this.config);
		},
		async startImport(){
			if (this.isFtpDataEmpty) return;
			if (this.config.SupplierID == 0) return;
			await ProductService.importFromKramp();
		},
		async fetchSupplier(){
			if (this.config.SupplierID == 0) {
				this.krampSupplier = null;
				return;
			}
			this.krampSupplier = await SupplierService.getContact(this.config.SupplierID);
		},
		setKrampSupplier(value:Contact | null){
			this.krampSupplier = value;
			this.config.SupplierID = 0;
			if (value) {
				this.config.SupplierID = value.ID;
			}
		}
	},
	async mounted(){
		await this.fetchSupplier();
	},
	components: {
		AppMissingModule,
		AppContactSearchWithBrowseAndCreate
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
